import $ from "jquery";

const fedcm = {

	init() {

		$(".logout__link").on('click', function(event) {
			navigator.credentials.preventSilentAccess();
		});

		if(
			typeof customer_logged != "undefined" &&
			customer_logged === false &&
			typeof fedCmProviders != "undefined" &&
			"IdentityCredential" in window
		) {
			async function getCredential() {
				try {
					const credential = await navigator.credentials.get({
						identity: {
							context: "signin",
							providers: fedCmProviders
						}
					});

					fedcm.login(credential);

				} catch (e) {
					console.log(e);
					// fedcm.error();
				}
			}

			getCredential();
		}
	},

	login(credential) {
		this.overlayShow();
		$.ajax(ROOT, {
			type: 'POST',
			data: {
				page: 'user',
				subpage: 'oauth',
				action: 'fedcmlogin',
				credential: credential
			},
			success: (response) => {
				window.location.reload();
			},
			error: (response) => {
				this.error();
				this.overlayHide();
			},
			async: false,
			dataType: 'json'
		});
	},


	error() {
		iziToast.warning({
			title: 'Chyba',
			message: 'Došlo k chybě při přihlašování.',
			position: 'center'
		});
	},

	overlayShow() {
		$.LoadingOverlay("show", {
			background: "rgba(225, 225, 225, 0.5)",
			imageColor: "#808080",
			size: "70px"
		});
	},

	overlayHide() {
		$.LoadingOverlay("hide");
	},

};

fedcm.init();